import React from "react";

const TailwindLoadingSpinner = () => (
  <div className="flex items-center justify-center space-x-2">
    <div className="w-4 h-4 border-2 border-blue-600 rounded-full border-t-transparent animate-spin"></div>
    <span className="text-base font-base">Loading...</span>
  </div>
);

export default TailwindLoadingSpinner;
